import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["video", "onPlay", "onError", "data-test-id", "className", "layoutType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { isValidElement, useCallback, useRef, useState } from 'react';
import { PlaySVG } from '@sbercloud/uikit-product-icons';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { IconPredefined } from '@snack-uikit/icon-predefined';
import styles from "./styles.module.css";
import { isVideoPlayerContent, preventDefault } from './utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function SiteVideo(_ref) {
  var video = _ref.video,
    onPlay = _ref.onPlay,
    onError = _ref.onError,
    _ref$dataTestId = _ref['data-test-id'],
    dataTestId = _ref$dataTestId === void 0 ? 'site-video' : _ref$dataTestId,
    className = _ref.className,
    layoutType = _ref.layoutType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var videoRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVideoPlayed = _useState2[0],
    setIsVideoPlayed = _useState2[1];
  var handleVideoPlay = useCallback(function () {
    var _videoRef$current;
    setIsVideoPlayed(true);
    (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.play();
    onPlay === null || onPlay === void 0 ? void 0 : onPlay();
  }, [onPlay]);
  var isCustomVideoPlayer = /*#__PURE__*/isValidElement(video);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: cn(styles.videoWrapper, className),
    "data-test-id": dataTestId
  }, extractSupportProps(rest)), {}, {
    children: [isCustomVideoPlayer && video, isVideoPlayerContent(video) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("video", {
        src: video.src,
        poster: video.poster,
        ref: videoRef,
        "data-test-id": "".concat(dataTestId, "__video"),
        preload: "auto",
        disablePictureInPicture: true,
        controlsList: "nodownload noplaybackrate",
        controls: isVideoPlayed && video.controls,
        autoPlay: video.autoPlay,
        playsInline: true,
        onContextMenu: preventDefault,
        muted: video.muted || video.autoPlay,
        loop: video.loop,
        onError: onError
      }), !isVideoPlayed && video.controls &&
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      _jsx("div", {
        className: styles.videoOverlay,
        onClick: handleVideoPlay,
        children: /*#__PURE__*/_jsx(IconPredefined, {
          size: layoutType === 'mobile' ? 'm' : 'l',
          shape: "square",
          appearance: "neutral",
          icon: PlaySVG,
          className: styles.playButton,
          "data-test-id": "".concat(dataTestId, "__play-button")
        })
      })]
    })]
  }));
}